var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounseling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.398438,
    width: 60,
    height: 60,
    rx: 16,
    fill: "#26B0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7331 39.4445V24.3334C41.7331 18.0741 36.659 13 30.3998 13V13C24.1405 13 19.0664 18.0741 19.0664 24.3334V39.4445",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7314 39.4443C41.7314 43.6172 38.3486 46.9999 34.1758 46.9999",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1245 40.7638C40.7221 40.7762 40.4091 40.4497 40.4091 40.0672L40.4091 33.7779V27.4886C40.4091 27.106 40.7221 26.7795 41.1245 26.7919C42.9001 26.8466 44.5914 27.5758 45.8513 28.8357C47.1621 30.1464 47.8984 31.9242 47.8984 33.7779C47.8984 35.6315 47.1621 37.4093 45.8513 38.72C44.5914 39.9799 42.9001 40.7091 41.1245 40.7638Z",
    fill: "#BEECFF",
    stroke: "#BEECFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7979 40.8897C20.2001 40.9018 20.513 40.5755 20.513 40.1929L20.513 33.778V27.3631C20.513 26.9805 20.2001 26.6542 19.7979 26.6663C17.989 26.721 16.2656 27.4635 14.982 28.747C13.6477 30.0813 12.8981 31.891 12.8981 33.778C12.8981 35.665 13.6477 37.4747 14.982 38.809C16.2656 40.0925 17.989 40.835 19.7979 40.8897Z",
    fill: "#BEECFF",
    stroke: "#BEECFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounseling);
export default __webpack_public_path__ + "static/media/counseling.259d40692efa98041e4f31915edc819c.svg";
export { ForwardRef as ReactComponent };